import { HostListener, Component, Input, OnDestroy, Inject, ViewEncapsulation } from '@angular/core';
import { Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError, RouterEvent } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { Subject } from 'rxjs';
import { delay, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-spinner',
  template: `<div class="preloader" [style.background-color]=backgroundColor *ngIf="isSpinnerVisible">
        <div class="spinner">
          <div class="double-bounce1"></div>
          <div class="double-bounce2"></div>
        </div>
    </div>`,
  encapsulation: ViewEncapsulation.None
})
export class SpinnerComponent implements OnDestroy {

  unsubscribe = new Subject<void>();
  public isSpinnerVisible = true;

  @Input()
  public backgroundColor = '#6e6e6e94';

  constructor(private router: Router, @Inject(DOCUMENT) private document: Document) {
    // console.log('subscribing ...');
    this.router.events.pipe(takeUntil(this.unsubscribe))
      .subscribe((routerEvent) => {
        this.checkRouterEvent(routerEvent as RouterEvent);
      });
  }

  message = "Window not loaded";

  @HostListener('load', ['$event'])
  windowLoadedEvent() {
    this.message = "Window loaded";
    console.log(this.message);
  }


  checkRouterEvent(routerEvent: RouterEvent): void {
    if (routerEvent instanceof NavigationStart) {
      this.isSpinnerVisible = true;
      // console.log('starting.');
    }

    // if (document.readyState === "complete" && this.document.readyState === "interactive") {
    //   console.log('complete or interactive.');
    // }

    // if (document.readyState === "complete") {
    //   console.log('complete ');
    // }

    // if (document.readyState === "interactive") {
    //   console.log('interactive.');
    // }

    if (routerEvent instanceof NavigationEnd ||
      routerEvent instanceof NavigationCancel ||
      routerEvent instanceof NavigationError) {
      setTimeout(() => {
        this.isSpinnerVisible = false;
        // console.log('done.');
      },
        1000);
    }
  }

  ngAfterViewInit() {

  }

  ngAfterViewChecked() {

  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
  }

  // constructor(
  //   private router: Router,
  //   @Inject(DOCUMENT) private document: Document
  // ) {
  //   this.router.events.subscribe(
  //     event => {
  //       if (event instanceof NavigationStart) {
  //         this.isSpinnerVisible = true;
  //       } else if (
  //         event instanceof NavigationEnd ||
  //         event instanceof NavigationCancel ||
  //         event instanceof NavigationError
  //       ) {
  //         this.isSpinnerVisible = false;
  //       }
  //     },
  //     () => {
  //       this.isSpinnerVisible = false;
  //     }
  //   );
  // }

  // ngOnDestroy(): void {
  //   this.isSpinnerVisible = false;
  // }

}
